import * as React from 'react';
import MainRow from '../../../layouts/baseLayouts/mainRow';
import { CanAddProspectTeamsBanner } from '../../../components/teamBanner';
import CreateProspect from '../createProspect';
import ProspectEvaluationHistory from '../prospectEvaluationHistory';
import DeviceProfiles from '../../training/deviceProfiles';

interface ScoutDashboardProps {
	isGuardVision?: boolean;
}

export class ScoutDashboard extends React.Component<ScoutDashboardProps> {
	public render(): JSX.Element {
		const { isGuardVision } = this.props;
		return (
			<>
				<MainRow>
					<CanAddProspectTeamsBanner>
						{!isGuardVision && (
							<div>
								<DeviceProfiles />
							</div>
						)}
					</CanAddProspectTeamsBanner>
				</MainRow>
				<MainRow>
					<CreateProspect isGuardVision={isGuardVision} />
					{!isGuardVision && <ProspectEvaluationHistory />}
				</MainRow>
			</>
		);
	}
}

export default ScoutDashboard;
